<template>
  <CallPlanningLayout :userId="userId" prop="manager">
    <DataTable :data="tableData" :perPage="25">
      <template #menu>
        <div class="hvh-flex align-center">
          <div :class="{ disabled: !isAnySelected }">
            <v-btn flat class="hvh-btn hvh-btn--secondary" @click="approveRequest">Approve</v-btn>
            <v-btn flat class="hvh-btn hvh-btn--secondary" @click="denyRequest">Deny</v-btn>
          </div>
          <router-link class="users-link ml-4" :to="{ name: 'callPlanningManagerUsers', brandId }">Users</router-link>
        </div>
      </template>
      <template #head>
        <tr>
          <th>
            <CheckBox :value="isAllSelected" :half="!isAllSelected && isAnySelected" @input="onSelectAllChange" />
          </th>
          <Th :prop="column.column" sort export v-for="column in columns" :key="column.column">{{ column.text }}</Th>
          <Th prop="createdBy.email" sort>Created By</Th>
          <Th prop="createdAt" sort>Created At</Th>
          <Th prop="type" sort>Type</Th>
          <Th prop="reason" sort>Reason</Th>
          <Th prop="value" sort>Value</Th>
          <!-- <th>Item</th> -->
          <th />
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td class="text-center">
            <CheckBox :value="selected.includes(item)" @input="onSelectChange(item)" />
          </td>
          <td v-for="column in columns" :key="column.column">{{ item.brandTarget.physicianGroupList[column.column] || '-' }}</td>

          <td>
            <router-link :to="{ name: 'callPlanningManagerUser', params: { userId: item.createdBy.email } }" target="_blank">{{ item.createdBy.email }}</router-link>
          </td>
          <td>{{ browserDateTime(item.createdAt) }}</td>
          <td>{{ item.type.splitByUpperCase().join(' ') }}</td>
          <td>{{ item.reason }}</td>
          <td>{{ item.value }}</td>
          <td>
            <CallPlaningRequests :value="item" :type="item.type" />
          </td>
        </tr>
      </template>
    </DataTable>
    <Loader v-if="!data || isLoading" />
  </CallPlanningLayout>
</template>

<script>
import axios from '../../axios';
import CallPlanningLayout from '../../components/callPlanning/CallPlanningLayout.vue';
import DataTable from '../../components/common/dataTable/DataTable.vue';
import Th from '../../components/common/dataTable/Th.vue';
import { createFormData, errorDebug, tryParse } from '../../libraries/common';
import CheckBox from '../../components/common/form/checkbox/CheckBox.vue';
import CallPlaningRequests from '../../components/callPlanning/CallPlaningRequests.vue';
export default {
  components: { DataTable, Th, CallPlanningLayout, CheckBox, CallPlaningRequests, },
  title: 'Call Planning',
  data() {
    return {
      data: null,
      isLoading: false,
      detailItem: null,
      selected: [],
      columns: [],
    };
  },
  computed: {
    tableData() {
      return (this.data || [])
        .filter(f => !f.reviewedBy)
        .map(f => {
          return ({
            ...f,
            requests: this.data
              .filter(g => g.brandTarget.physicianGroupList.id === f.brandTarget.physicianGroupList.id && f.id !== g.id),
          })
        });
    },
    brandId() {
      return this.$route.params.brandId;
    },
    sellectAllColor() {
      return this.selected.length >= (this.data || []).length ? '#11697d' : 'grey';
    },
    isAllSelected() {
      return this.tableData.any() && this.tableData.all(f => this.selected.includes(f));
    },
    isAnySelected() {
      return this.selected.any();
    },
    userId() {
      return this.$store.state.user.user.email;
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      return axios.get(`/api/CallPlanning/${this.brandId}/Manager/Requests`)
        .then(({ data }) => this.data = data
          .map(f => ({
            ...f,
            brandTarget: {
              ...f.brandTarget,
              physicianGroupList: {
                ...f.brandTarget.physicianGroupList,
                ...(tryParse(f.brandTarget.physicianGroupList.additionalData) || {})
              },
            },
          })))
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    requestChanges(item, data) {
      return axios.post(`/api/CallPlanning/${this.brandId}/Manager/Requests/${item.id}`, createFormData(data))
        .then(() => this.data = this.data.filter(f => f.id !== item.id))
        .catch(errorDebug);
    },
    approveRequest() {
      this.$confirm('Approve the request', `You are about to approve the requests.`,
        {
          optionMessage: 'Give us the reason for approving',
          optionComponent: 'v-textarea',
        })
        .then(reason => {
          var all = this.selected.map(f => this.requestChanges(f, { isApproved: true, reason: reason || '' }));
          this.isLoading = true;
          Promise.all(all)
            .then(() => this.selected = this.selected.filter(f => this.data.includes(f)))
            .then(() => this.isLoading = false);
        })
        .catch(() => null);
    },
    denyRequest() {
      this.$confirm('Deny the request', `You are about to deny the requests.`,
        {
          optionMessage: 'Give us the reason for the denial',
          optionComponent: 'v-textarea',
          optionRequired: true,
        })
        .then(reason => {
          var all = this.selected.map(f => this.requestChanges(f, { isApproved: false, reason: reason || '' }));
          this.isLoading = true;
          Promise.all(all)
            .then(() => this.selected = this.selected.filter(f => this.data.includes(f)))
            .then(() => this.isLoading = false);
        })
        .catch(() => null);
    },
    onSelectAllChange() {
      this.selected = this.isAllSelected ? [] : [...this.tableData];
    },
    onSelectChange(event) {
      this.selected = this.selected.toggle(event);
    },
  },
  watch: {
    brandId() {
      this.data = null;
      this.getData();
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanningManager'] = this;

    this.isLoading = true;
    axios.get(`/api/CallPlanning/Brands/${this.brandId}/Columns`)
      .then(({ data }) => this.columns = tryParse(data).filter(f => f.show))
      .then(this.getData)
      .catch(errorDebug)
      .then(() => this.isLoading = false);
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: #002f6c;
  border-bottom: 1px solid #002f6c;
  cursor: pointer;
}

.users-link {
  font-weight: 600;
  font-size: 1.0714285714rem;
  letter-spacing: 1.3px;
  text-transform: uppercase;
}
</style>